import api from "@api"
import { useStore } from "@stores"

export const readOperation = api.get("backstage/ReadPublicPublishedProject")
export const indexOperation = api.get("backstage/IndexPublishedProjects")


const useProjectsStore = (request, shouldAutoLoad = true) => {
  const {
    items: projects,
    getItem: getProject,
    indexItems: indexProjects,
    updateItem,
  } = useStore(indexOperation.id, request, shouldAutoLoad)

  const loadProject = id =>
    request(readOperation.id, { id })
      .then(({ data }) => updateItem({ ...getProject(id), ...data }))

  return {
    projects,
    getProject,
    loadProject,
    indexProjects,
  }
}

export default useProjectsStore
